export const baseFontSize = 16
export default baseFontSize
